import truthPfp from "../../../assets/blog/666_truth.png";
import zeroPfp from "../../../assets/blog/zero.es.png";
import waspesitoPfp from "../../../assets/blog/waspesito.png";
import loominartiPfp from "../../../assets/blog/loominarti.png";
import missAyuPfp from "../../../assets/blog/miss-ayu.png";
import catfishmcPfp from "../../../assets/blog/catfishmc.png";
import techgromansaPfp from "../../../assets/blog/techgromansa.png";
import d3monQueenPfp from "../../../assets/blog/d3mon.queen.png";
import hoodcruxPfp from "../../../assets/blog/hoodcrux.png";
import slowerslaypussykatPfp from "../../../assets/blog/slowerslaypussykat.png";

export const BLOG_AUTHORS = [
  { id: "666_truth", label: "666_truth", avatar: truthPfp },
  { id: "zero.es", label: "zero.es", avatar: zeroPfp },
  { id: "waspesito", label: "waspesito", avatar: waspesitoPfp },
  { id: "loominarti", label: "loominarti", avatar: loominartiPfp },
  { id: "miss-ayu", label: "miss-ayu", avatar: missAyuPfp },
  { id: "catfish", label: "catfish", avatar: catfishmcPfp },
  { id: "techgromansa", label: "techgromansa", avatar: techgromansaPfp },
  { id: "d3mon.queen", label: "d3mon.queen", avatar: d3monQueenPfp },
  { id: "hoodcrux", label: "hoodcrux", avatar: hoodcruxPfp },
  { id: "slaypussykat", label: "slaypussykat", avatar: slowerslaypussykatPfp },
];

export const BLOG_AUTHOR_MAP = BLOG_AUTHORS.reduce((acc, author) => {
  acc[author.id] = author;
  return acc;
}, {});

export const getBlogAuthor = (authorId) =>
  BLOG_AUTHOR_MAP[authorId] || {
    id: authorId || "unknown",
    label: authorId || "unknown",
    avatar: truthPfp,
  };
